const lang = {
    'desp': '本網站將使用 Cookie 紀錄及存取您的瀏覽資料，繼續使用本網站，表示您同意我們使用 Cookie，更多關於 Cookie 之使用及隱私權保護之資訊，請詳閱%{term}。',
    'link': '隱私權政策',
    'accept': '我接受',
};

export default lang;
